// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".listAction__listItemContainer___2knuG{justify-content:flex-end;align-items:flex-end;width:100%;cursor:pointer}.listAction__listItemContainer___2knuG .listAction__listItem___1OZ1L{border-radius:3px;padding:10px;background-color:var(--agent-bubble-background-color);box-shadow:0 2px 6px 0 rgba(201,201,201,.5);color:var(--agent-bubble-primary-font-color);margin-top:10px;display:flex;align-items:center}.listAction__listItemContainer___2knuG .listAction__listItem___1OZ1L:hover{box-shadow:0 0 5px 0 var(--primary-button-background-hover-color)}.listAction__listItemContainer___2knuG img{width:100px;height:70px}.listAction__infoContainer___TTBHH{display:flex;flex-direction:column;margin-left:10px}.listAction__detailsText___31fs-{margin-top:10px;color:var(--agent-bubble-secondary-font-color);font-size:12px}html[dir=\"rtl\"] .listAction__infoContainer___TTBHH{margin-left:initial;margin-right:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "655px",
	"listItemContainer": "listAction__listItemContainer___2knuG",
	"listItem": "listAction__listItem___1OZ1L",
	"infoContainer": "listAction__infoContainer___TTBHH",
	"detailsText": "listAction__detailsText___31fs-"
};
export default ___CSS_LOADER_EXPORT___;
